// extracted by mini-css-extract-plugin
module.exports = {"link":"Form_link__SjPRK","control":"Form_control__g_WLk","textarea":"Form_textarea__yVTvo"};